import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';

@Component({
  selector: 'app-update-opening-balance',
  templateUrl: './update-opening-balance.component.html',
  styleUrls: ['./update-opening-balance.component.scss']
})
export class UpdateOpeningBalanceComponent implements OnInit ,OnChanges {
  accountOpeningBalancetForm: FormGroup;
  accountOpeningBalance: boolean = true;
  startingDate :Date = new Date();
  @Input() decimalPlaces : number  = 0 ;
  @Input() isFlag: boolean;
  @Input() selectedId: number;
  @Input() selectedVendor: number;
  @Output() passAccountOpeningBalance = new EventEmitter<boolean>();
  constructor(private fb: FormBuilder,private app :AppMainComponent,
     private accountService: AccountServiceN, 
     private messageService: MessageService, 
     public appMainService: AppMainService,
     private purchaseService: PurchasesService,) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.accountOpeningBalance = this.isFlag
    }
  }

  ngOnInit(): void {
    this.accountOpeningBalancetForm = this.fb.group({
      id: [0],
      OpeningBalanceValue:  ['', Validators.required],
      startingDate: [new Date(), Validators.required],
    });
  }

  saveAccountOpeningBalancetForm(e) {
    let date = new Date(e.startingDate); 
    // Add current Hr,min,sec
    date.setHours(new Date().getHours()); 
    date.setMinutes(new Date().getMinutes()); 
    date.setSeconds(new Date().getSeconds());
    let newDate = date; 

    let queryParaDate = newDate.toISOString();

    const Obj = {
      accountId: this.selectedVendor ? this.selectedVendor : this.selectedId,
      openingBalance: +e.OpeningBalanceValue,
      startingDate:this.app._saveDateTimeWithZone(newDate)
    }

    this.appMainService.isShowSpinner('OpeningBalance');
    if(this.selectedVendor){
    this.purchaseService.addAccountOpeningBalance(Obj,queryParaDate).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('OpeningBalance');
        this.accountOpeningBalance = false;
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail:  "OpeningBalance saved successfully...",
      });
        this.accountOpeningBalance = false
        this.passAccountOpeningBalance.emit(false);
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
        this.appMainService.isHideSpinner('OpeningBalance');
        this.accountOpeningBalance = false
        this.passAccountOpeningBalance.emit(false);
      },
      complete: () => {
        this.accountOpeningBalance = false
        this.passAccountOpeningBalance.emit(false);
        this.appMainService.isHideSpinner('OpeningBalance');
      },
    });
    }else if(this.selectedId){
      this.accountService.addAccountOpeningBalance(Obj,queryParaDate).subscribe({
        next: (response) => {
        this.appMainService.isHideSpinner('OpeningBalance');
          this.accountOpeningBalance = false;
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail:  "OpeningBalance saved successfully...",
        });
          this.accountOpeningBalance = false
          this.passAccountOpeningBalance.emit(false);
        },
        error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
        this.appMainService.isHideSpinner('OpeningBalance');
          this.accountOpeningBalance = false
          this.passAccountOpeningBalance.emit(false);
        },
        complete: () => {
          this.accountOpeningBalance = false
          this.passAccountOpeningBalance.emit(false);
          this.appMainService.isHideSpinner('OpeningBalance');
        },
      });
    }
    this.accountOpeningBalancetForm.reset()
    this.startingDate = new Date()

    this.accountOpeningBalance = false;
    this.passAccountOpeningBalance.emit(false);
  }

  CancelPopup(){
    this.isFlag = false
    this.passAccountOpeningBalance.emit(false);
    this.accountOpeningBalancetForm.reset()
    this.startingDate = new Date()
  }

}
